import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import fr from 'facet-rest';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import RecurringExpenseItems
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseItems';
import NoOneTimeExpensesContainer
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingOneTimeExpenses/NoOneTimeExpensesContainer';
import MissingInformationConfirmationDialog
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/MissingInformationConfirmationDialog';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import ExpenseStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/ExpenseStepHeader';
import RecurringExpenseItemOneTime
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseItemOneTime';

function OnboardingOneTimeExpenses() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { refreshOnboardingStepCollection } = useSurveyContext();
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const {
    setOnboardingStepCollection,
  } = useSurveyContext();
  useScrollTopOnMount();

  const oneTimeExpenseItems = resource.attr('items').resources().list();

  const handleAddNewExpense = async (rel) => {
    try {
      await rel.link('related').post({});
      await refreshOnboardingStepCollection();
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to add new expense.');
    }
  };

  const handleSubmitFromConfirmation = async () => {
    try {
      const newOnboardingCollection = await onSubmitMetaForm();
      setOnboardingStepCollection(newOnboardingCollection);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to submit');
    }
  };

  const handleSubmit = async () => {
    try {
      const [tmpResource] = await resource.link('self').get();
      tmpResource.withRelationship(fr.relationships.missingInformationConfirmation.name, () => {
        setShowConfirmation(true);
      }, async () => {
        await handleSubmitFromConfirmation();
      });
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to submit');
    }
  };

  if (!resource) return null;
  return (
    <React.Fragment>
      <FDStack direction={'column'} spacing={4}>
        <ExpenseStepHeader resource={resource} />
        <FDStack direction={'column'} spacing={2}>
          {
            oneTimeExpenseItems.length === 0 ? (
              <NoOneTimeExpensesContainer description={resource.attr('noExpenseDescription')} />
            ) : (
              <RecurringExpenseItems items={oneTimeExpenseItems} RecurringExpenseItemComponent={RecurringExpenseItemOneTime} />
            )
          }
          <OnboardingAddItemButton relationship={resource.relationship(fr.relationships.addItem.name)} onAdd={handleAddNewExpense} />
        </FDStack>
        <SurveyStepFooter
          onSubmit={handleSubmit}
          nextButtonLabel={'Continue'}
        />
      </FDStack>
      <MissingInformationConfirmationDialog
        relationship={resource.relationship(fr.relationships.missingInformationConfirmation.name)}
        isOpen={showConfirmation}
        setOpen={setShowConfirmation}
        handleNext={handleSubmitFromConfirmation}
      />
    </React.Fragment>
  );
}

OnboardingOneTimeExpenses.propTypes = {
};

OnboardingOneTimeExpenses.defaultProps = {
};

export default OnboardingOneTimeExpenses;
